export default "<kt-splash-screen *ngIf=\"loader\"></kt-splash-screen>\r\n<kt-loader></kt-loader>\r\n<router-outlet></router-outlet>"